import { TableColumn } from '@maersk-global/mds-components-core/mc-table/types';
import { utils } from '../../../helper/utils';
import { getPartSupplierTypeDisplayText } from '../../../form-model/part-supplier-type.model';

export const shopManagementGridColumns: Array<TableColumn> = [
  {
    id: 'shopCode',
    label: 'Shop Code',
    sortDisabled: true,
  },
  {
    id: 'name',
    label: 'Description',
    sortDisabled: true,
  },
  {
    id: 'partSupplierType',
    label: 'Type',
    dataType: {
      type: 'string',
      formatter: (value: any) => {
        return getPartSupplierTypeDisplayText(value as any);
      },
    },
    sortDisabled: false,
  },
  {
    id: 'locationCode',
    label: 'Shop Location',
    sortDisabled: false,
  },
  {
    id: 'isActiveDisplay',
    label: 'Status',
    sortDisabled: true,
  },
  {
    id: 'currencyCode',
    label: 'Currency',
    dataType: {
      type: 'string',
      formatter: (_value, row: any) => {
        const { currencyCode, currencyName } = row.original ?? {};
        return `${currencyCode ?? ''} - ${currencyName ?? ''}`;
      },
    },
    sortDisabled: true,
  },
  {
    id: 'updatedAt',
    label: 'Last Updated',
    dataType: {
      type: 'string',
      formatter: (value) => {
        const date = new Date(value as string);
        return utils.dateFormatter.format(date);
      },
    },
    sortDisabled: false,
  },
];
